import { render } from "./NewSingleFileUploadTemplate.vue?vue&type=template&id=0ea52c48"
import script from "./NewSingleFileUploadTemplate.vue?vue&type=script&lang=js"
export * from "./NewSingleFileUploadTemplate.vue?vue&type=script&lang=js"

import "./NewSingleFileUploadTemplate.vue?vue&type=style&index=0&id=0ea52c48&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__